<span class="checkbox__caption">
    <ng-content></ng-content>
</span>

